import CheckOrders from '../components/business/CheckOrders'
import ActiveOrdersProvider from './activeOrders'
import { MenuProvider } from './menu'
import { SellerProvider } from './seller'
import OrdersWebSocketProvider from './ordersWebSocket'

const AppProvider = ({ children }) => {
  return (
    <SellerProvider>
      <OrdersWebSocketProvider>
        <ActiveOrdersProvider>
          <MenuProvider>
            <CheckOrders />
            {children}
          </MenuProvider>
        </ActiveOrdersProvider>
      </OrdersWebSocketProvider>
    </SellerProvider>
  )
}

export default AppProvider
